import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Input, FormGroup, Button, Card, CardHeader, CardBody,Table, Spinner, Collapse, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import uuid from 'react-uuid';
import { FaPlus, FaChevronUp, FaChevronDown, FaUpload, FaTrash } from 'react-icons/fa';
import Moment from 'moment';
import toast, { Toaster } from 'react-hot-toast';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import moment from "moment";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const HistoricalActions = ({ open, showArrow, sectionId }) => {
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const roleName = localStorage.getItem("roleName");
    const isCreateNewAction = localStorage.getItem("isCreateNewAction");
    const [isOpen, setIsOpen] = useState(open);
    const [isIconUp, setIsIconUp] = useState(false);
    const toggle = () => {
        setIsOpen(!isOpen);
        setIsIconUp(!isIconUp);
    }; const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/action/GetHistoricalActions/', {
                    params: {
                        farmId: farmId, sectionId: sectionId
                }
            }
            );
            setHistoricalActions(response.data.content);
            let tempErrors = [];
            response.data.content.forEach(function (element) {
                const error = {
                    fileError: '', detail:''
                };
                tempErrors.push(error);
            });
            setFormErrors(tempErrors);
        } catch (err) {
            console.log(err);
        }
    }
    useEffect(() => {
        OnPageload();
    }, [])
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [formErrors, setFormErrors] = useState({});
    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }
    const [historicalActions, setHistoricalActions] = useState([]);
    const [addNewActionPopup, setAddNewActionPopup] = useState({ showPopup: false, editActionTitle: 'Add Action', id: 0, Detail: '', ImageName: '', ImagePhysicalName: '', ImagePath:'' });
    const [dateCompleted, setDateCompleted] = useState(null);
    let inputFile = [];
    const handleShowAddNewActionPopup = (id) => {
        if (id == 0) {
            setAddNewActionPopup({ showPopup: true, id: id });
        }
        else {
            var action = historicalActions.filter(x => x.id == id);
            if (action.length > 0) {
                setAddNewActionPopup({ showPopup: true, id: id, Detail: action[0].detail });
                if (action[0].dateCompleted != null) {
                    setDateCompleted(getDateFromString(moment(action[0].dateCompleted).format("DD/MM/YYYY")));
                }
                setImageName(action[0].imageName);
                setImagePreviewUrl(action[0].imageRelativePath);
                setImagePhysicalFilename(action[0].imagePhysicalName);
                setImagePhysicalFilepath(action[0].imagePath);
            } 
        }
    }
    const handleSaveAddNewActionPopup = async (e) => {
        e.preventDefault();
        const tempErrors = [...formErrors];
        var errorFound = false;
        setAddNewActionSaving(true);
        let tempHistoricalActions = [...historicalActions];
        let form = {
            FarmId: farmId,
            HistoricalActions: [],
            UserId: userId,
            SectionId: sectionId
        }
        for (var i = 0; i < tempHistoricalActions.length; i++) {
            var obj = {};
            obj.Id = tempHistoricalActions[i].id;
            obj.FarmId = farmId;
            if (tempHistoricalActions[i].detail == undefined || tempHistoricalActions[i].detail == null || tempHistoricalActions[i].detail == '') {
                tempErrors[i].detail = 'This is mandatory';
                errorFound = true;
            }
            else
            {
                tempErrors[i].detail = '';
            }
            obj.Detail = tempHistoricalActions[i].detail;
            obj.DateCompleted = tempHistoricalActions[i].dateCompleted != null ? tempHistoricalActions[i].dateCompletedString : "";
            obj.ImageName = tempHistoricalActions[i].imageName;
            obj.ImagePath = tempHistoricalActions[i].imagePath;
            obj.ImagePhysicalName = tempHistoricalActions[i].imagePhysicalName;
            obj.ImageRelativePath = tempHistoricalActions[i].imageRelativePath;
            obj.SectionId = tempHistoricalActions[i].sectionId;
            form.HistoricalActions.push(obj);
        }
        setFormErrors(tempErrors);
        if (!errorFound) {
            const response = await apiPost(
                '/api/action/SaveHistoricalAction/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data != null) {
                setAddNewActionSaving(false);
                if (response.data.status) {
                    setHistoricalActions(response.data.content);
                    toast.success("Historical Action saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                }
            }
        }
        else {
            setAddNewActionSaving(false);
            return false;
        }
    }
    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }
    const handleHideAddNewActionPopup = () => {
        setAddNewActionPopup({ showPopup: false, id: 0 });
    }
    const [addNewActionSaving, setAddNewActionSaving] = useState('');
    function handleInputChange(event) {
        const { name, value, checked, type } = event.target;
        setAddNewActionPopup({ ...addNewActionPopup, [name]: type == 'checkbox' ? checked : value });
    }
    const handleSetDateCompleted = (date) => {
        setDateCompleted(date);
    }

    const [imageFile, setImageFile] = useState('');
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [imageName, setImageName] = useState('');
    const [imagePhysicalFilename, setImagePhysicalFilename] = useState('');
    const [imagePhysicalFilepath, setImagePhysicalFilepath] = useState('');

    let inputImageFile = ''; const [imageViewPopup, setImageViewPopup] = useState({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    const handleBtnImageUploadClick = async (e) => {
        e.preventDefault();
        inputImageFile.click();
        return false;
    }

    const handleRecordChange = async (e, idx) => {
        e.preventDefault();
        const tempErrors = [...formErrors];
        let reader = new FileReader();
        let file = e.target.files[0];
        const errors = {};
        if (file.type != 'image/png' && file.type != 'image/jpeg' && file.type != 'image/jpg') {
            errors.fileError = "Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.";
            tempErrors[idx].fileError = "Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.";
        }
        else if ((file.size / (1024 * 1024)) > 5) {
            errors.fileError = "Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.";
            tempErrors[idx].fileError = "Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.";
        }
        const tempRows = [...historicalActions];
        setFormErrors(tempErrors);
        if (Object.keys(errors).length == 0) {
            getBase64(file)
                .then(result => {
                    let form = {
                        FileName: file.name.replace(/\.[^/.]+$/, ""),
                        Type: "HistoricalAction",
                        Base64Image: result, FarmId: farmId
                    }
                    const response = apiPost(
                        '/api/upload/UploadImage/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        }).then(res => {
                            if (res.data != null) {
                                if (res.data.status) {
                                    tempRows[idx].imagePhysicalName = res.data.content.PhysicalFilename;
                                    tempRows[idx].imageRelativePath = res.data.content.RelativeFilepath;
                                    tempRows[idx].imagePath = res.data.content.PhysicalFilepath;
                                    setHistoricalActions(tempRows);
                                }
                            }
                        });
                })
                .catch(err => {
                    console.log(err);
                });

            reader.onloadend = () => {
                tempRows[idx].imageName = file.name;
                tempRows[idx].imageRelativePath = reader.result;
            }

            reader.readAsDataURL(file)
        }
        else {
            e.target.value = null;
        }
    }

    const handleImageChange = async (e) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file.type != 'image/png' && file.type != 'image/jpeg' && file.type != 'image/jpg') {
            toast.error("Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            return false;
        }
        else if ((file.size / (1024 * 1024)) > 5) {
            toast.error("Image uploads must be in .jpg format and less than 5mb in size. Please adjust the file you are trying to upload and try again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            return false;
        }
        getBase64(file)
            .then(result => {
                let form = {
                    FileName: file.name.replace(/\.[^/.]+$/, ""),
                    Type: "HistoricalAction",
                    Base64Image: result, FarmId: farmId
                }
                const response = apiPost(
                    '/api/upload/UploadImage/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }).then(res => {
                        if (res.data != null) {
                            if (res.data.status) {
                                setImagePreviewUrl(res.data.content.RelativeFilepath);
                                setImagePhysicalFilename(res.data.content.PhysicalFilename);
                                setImagePhysicalFilepath(res.data.content.PhysicalFilepath);
                            }
                        }
                    });
            })
            .catch(err => {
                console.log(err);
            });

        reader.onloadend = () => {
            setImageName(file.name);
            setImageFile(file);
            setImagePreviewUrl(reader.result);
        }

        reader.readAsDataURL(file)
    }

    const getBase64 = async (file) => {
        return new Promise(resolve => {
            let fileInfo;
            let baseURL = "";
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };
    const handleImageViewPopup = (event, imageName, imageUrl) => {
        setImageViewPopup({ showImageViewPopup: true, imageName: imageName, imageUrl: imageUrl });
    }

    const handleImageViewPopupClose = (event) => {
        setImageViewPopup({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    }

    const handleDateChange = (idx, date) => {
        const tempRows = [...historicalActions];
        tempRows[idx].dateCompletedString = getParsedDate(date);
        tempRows[idx].dateCompleted = getDateFromString(getParsedDate(date));
        setHistoricalActions(tempRows);
    };

    const handleDetailsChange = idx => e => {
        const { name, value } = e.target;
        const tempRows = [...historicalActions];
        tempRows[idx].detail = value;
        setHistoricalActions(tempRows);
    };

    const handleBtnUploadClick = async (e, idx) => {
        e.preventDefault();
        inputFile[idx].click();
        return false;
    }

    const handleHistoricalActionsAddRow = () => {
        const item = {
            farmId: farmId,
            dateCompleted: null,
            dateCompletedString: '',
            detail: '',
            id: 0,
            imageName: null,
            imagePath: null, imagePhysicalName: null, imageRelativePath: null, sectionId: sectionId
        };
        setHistoricalActions([...historicalActions, item]);
        const error = {
            fileError: '', detail:''
        };
        setFormErrors([...formErrors, error]);
    };

    const handleRecordRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...historicalActions]
        const tempErrors = [...formErrors];
        tempRows.splice(idx, 1)
        tempErrors.splice(idx, 1)
        setHistoricalActions(tempRows);
        setFormErrors(tempErrors);
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="card-header-outline">
            {showArrow && <CardHeader className="card-header-click" onClick={toggle}>
                <Row>
                    <Col sm="11">
                        <h5>Historical Actions
                        </h5>
                    </Col>
                    <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                </Row>
            </CardHeader>}
            <Collapse isOpen={isOpen}>
                    <CardBody>
                        <Row>
                            <Col>
                                <h6>Actions and improvements may have been completed before the creation of this farm plan. Use the table below to record any relevant historical actions.</h6>
                            </Col>
                        </Row>
                        <Row style={{ marginTop: "2.5vh" }}>
                            <Col sm="8">
                            </Col>
                            <Col sm="4">
                                {(roleName == 'SWNZ Admin' || isCreateNewAction == 'true') &&
                                    <>
                                    <Button className="btn-items-actions" color="success" size="sm" onClick={handleHistoricalActionsAddRow} >
                                            <FaPlus /> Action
                                        </Button>
                                    </>
                                }
                            </Col>
                        </Row>
                        <Row className="my-3">
                            <Col>
                                {
                                    historicalActions!= undefined && historicalActions.length != 0 &&
                                    <>
                                        <table className="table table-bordered">
                                            <thead >
                                                <tr>
                                                    <th style={{ width: '5%' }}> # </th>
                                                    <th style={{ width: '40%' }}> Action Detail </th>
                                                    <th style={{ width: '20%' }}> Date Completed </th>
                                                    <th style={{ width: '30%' }}> Image </th>
                                                    <th style={{ width: '5%' }}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    historicalActions.map((action, idx) =>

                                                        <tr key={idx}>
                                                            <td> {historicalActions[idx].id == 0 ? '' : historicalActions[idx].id} </td>
                                                            <td>
                                                                {/*<textarea name="detail" value={historicalActions[idx].detail} onChange={handleDetailsChange(idx)} className="form-control" ></textarea>*/}
                                                                <textarea
                                                                    type="textarea" rows="2"
                                                                    name="detail"
                                                                    value={historicalActions[idx].detail}
                                                                    onChange={handleDetailsChange(idx)}
                                                                    className="form-control"
                                                                ></textarea>
                                                                {formErrors.length > 0 && formErrors[idx] != undefined && formErrors[idx].detail != undefined &&
                                                                    <p className="errorMessage">{formErrors[idx].detail}</p>
                                                                }
                                                            </td>
                                                            <td>
                                                                <DatePicker selected={historicalActions[idx].dateCompleted != null ? getDateFromString(moment(historicalActions[idx].dateCompleted).format("DD/MM/YYYY")) : null} onChange={(date) => handleDateChange(idx, date)} name="dateCompleted" dateFormat="dd/MM/yyyy" className="form-control" />
                                                                {/*{action.dateCompletedString }*/}
                                                            </td>
                                                            <td>
                                                                {historicalActions[idx].imageRelativePath != null && historicalActions[idx].imageRelativePath != '' ?
                                                                    <Row>
                                                                        <Col>
                                                                            <img height="75" width="75" src={historicalActions[idx].imageRelativePath} className="image-thumbnail" alt={historicalActions[idx].imageName} onClick={(event, imageName, imageUrl) => handleImageViewPopup(event, historicalActions[idx].imageName, historicalActions[idx].imageRelativePath)}></img>
                                                                            {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                                <>
                                                                                    <Button style={{ marginLeft: "10px" }} color="warning" size="sm" onClick={(e) => handleBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                                                </>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                    :
                                                                    <>
                                                                        {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                            <>
                                                                                <Button style={{ float: `right` }} color="success" size="sm" onClick={(e) => handleBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                                            </>
                                                                        }
                                                                    </>
                                                                }
                                                                <br />
                                                                <input style={{ float: `right`, display: 'none' }}
                                                                    ref={input => {
                                                                        inputFile[idx] = input;
                                                                    }}
                                                                    type="file" name="attachment" className="form-control" onChange={(e) => handleRecordChange(e, idx)} />
                                                                {formErrors.length > 0 && formErrors[idx] != undefined && formErrors[idx].fileError != undefined &&
                                                                    <p className="errorMessage">{formErrors[idx].fileError}</p>
                                                                }
                                                            </td>
                                                            <td>
                                                                <button style={{ float: "right" }} onClick={handleRecordRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                    <FaTrash />
                                                                </button>
                                                                {/*<Button className="text-end" color="primary" size="sm" onClick={(itemId, actionId) => handleShowAddNewActionPopup(action.id)} > Edit </Button>*/}
                                                            </td>
                                                        </tr>
                                                    )}
                                            </tbody>
                                        </table>
                                    </>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                    <>
                                    {addNewActionSaving ?
                                        <Button style={{ float: "right" }} onClick={handleSaveAddNewActionPopup}
                                                color="success"
                                                disabled
                                            >
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                        <Button style={{ float: "right" }} onClick={handleSaveAddNewActionPopup} color="success" size="sm">
                                                Save
                                            </Button>
                                        }
                                    </>
                                }
                            </Col>
                        </Row>
                </CardBody>
            </Collapse>
            </Card>
            <Modal isOpen={addNewActionPopup.showPopup}>
                <ModalHeader toggle={handleHideAddNewActionPopup} >{addNewActionPopup.editActionTitle}</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm="12">
                            <FormGroup>
                                <Label className="text-capitalize">Action Detail</Label>
                                <Input placeholder="" type="textarea" name="Detail" id="Detail" value={addNewActionPopup.Detail} onChange={handleInputChange} />
                            </FormGroup>
                            {formErrors.description != undefined &&
                                <p className="errorMessage">{formErrors.Detail}</p>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="12">
                            <FormGroup>
                                <Label className="text-capitalize">Date Completed</Label>
                                <DatePicker showYearDropdown yearDropdownItemNumber={15} style={{ width: `100%` }} selected={dateCompleted} onChange={(date) => handleSetDateCompleted(date)}
                                    name="dateCompleted" dateFormat="dd/MM/yyyy" className="form-control" />
                            </FormGroup>
                            {formErrors.description != undefined &&
                                <p className="errorMessage">{formErrors.Detail}</p>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label className="text-capitalize">Image upload</Label>
                                <div>
                                    {imagePreviewUrl && <img className="settings-image-style" src={imagePreviewUrl} onClick={(event, imageName, imageUrl) => handleImageViewPopup(event, imageName, imagePreviewUrl)} />}
                                    <br />
                                    {imagePreviewUrl ?
                                        <Button color="warning" size="sm" onClick={handleBtnImageUploadClick} ><FaUpload /> Modifiy Image</Button> :
                                        <Button color="success" size="sm" onClick={handleBtnImageUploadClick} ><FaUpload /> Upload Image</Button>}
                                    <input style={{ display: 'none' }}
                                        ref={input => {
                                            inputImageFile = input;
                                        }}
                                            className="fileInput" id="fileUpload" type="file" onChange={handleImageChange} />
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    {addNewActionSaving ?
                        <>
                            <Button onClick={handleSaveAddNewActionPopup} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Saving
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Saving...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={handleSaveAddNewActionPopup} color="primary">
                                Save
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleHideAddNewActionPopup}>Cancel</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={imageViewPopup.showImageViewPopup} size="lg" className="imageViewPopup">
                <ModalHeader toggle={handleImageViewPopupClose} >{imageViewPopup.imageName}</ModalHeader>
                <ModalBody>
                    <img src={imageViewPopup.imageUrl} className="item-image-popup" alt={imageViewPopup.imageName} ></img>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleImageViewPopupClose}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}
export default HistoricalActions